export default __webpack_public_path__ + "static/media/alarm-clock.f283c538.png";